import React from 'react'
import AppRouter from './components/AppRouter'

const App: React.FC = () => {
  return <AppRouter />
}

export default App
